import FilterChips from './FilterChips'

export default FilterChips
